import { render, staticRenderFns } from "./AddAttachmentGroup.vue?vue&type=template&id=22d0b237"
import script from "./AddAttachmentGroup.vue?vue&type=script&lang=js"
export * from "./AddAttachmentGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports